<template>
  <div class="logosCarousel">
    <div class="logosCarousel-slide">
      <div v-for="(image, index) in imagesURL" class="img-container position-relative align-middle" :key="index">
        <img :src="image" alt="Miniatura de la diapositiva." class="thumbnail img-fluid" :class="{ active: activeIndex === index }" @click="goToSlide(index)" />
      </div>
      <div v-for="(image, index) in imagesURL" class="img-container position-relative align-middle" :key="index">
        <img :src="image" alt="Miniatura de la diapositiva." class="thumbnail img-fluid" :class="{ active: activeIndex === index }" @click="goToSlide(index)" />
      </div>
      <div v-for="(image, index) in imagesURL" class="img-container position-relative align-middle" :key="index">
        <img :src="image" alt="Miniatura de la diapositiva." class="thumbnail img-fluid" :class="{ active: activeIndex === index }" @click="goToSlide(index)" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  props: {
    imagesURL: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeIndex: 0,
    };
  },
};
</script>

<style scoped>
@keyframes slide {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-100%);
  }
}

.logosCarousel {
  overflow: hidden;
  padding: 1.5dvh 0;
  white-space: nowrap;
  position: relative;
  min-width: 100dvw;

  &:before,
  &:after {
    position: absolute;
    top: 0;
    width: 30dvh;
    height: 10dvh;
    content: '';
    z-index: 1;
  }

  &:before {
    left: 0 !important;
    background: linear-gradient(to left, rgba(255, 255, 255, 0), 90%, var(--Sky));
  }

  &:after {
    right: 0 !important;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), 90%, var(--Sky));
  }
}

.logosCarousel-slide {
  display: inline-block;
  animation: 35s slide infinite linear;

  &:hover .logosCarousel-slide {
    animation-play-state: paused;
  }

  img {
    max-height: 5dvh;
    max-width: 15dvh;
    margin: 0 40px;
  }

  .img-container {
    position: relative;
    display: inline-block;

    .thumbnail {
      max-width: 6dvh;
      max-height: 15vh;
      object-fit: cover;
      border-radius: 5%;
      cursor: pointer;
      transition: transform 0.3s, border 0.3s;
      background-blend-mode: overlay;
    }
  }
}
</style>
